import { motion } from "framer-motion";
import { ArrowUpRight, Clock, Car } from "lucide-react";
import { DESTINOS } from "./data";
import { Reveal, Overline } from "./Reveal";
import { scrollToId } from "./scroll";

const SPANS = ["lg:col-span-7", "lg:col-span-5", "lg:col-span-4", "lg:col-span-4", "lg:col-span-4", "lg:col-span-12"];
const HEIGHTS = ["h-[440px] lg:h-[560px]", "h-[440px] lg:h-[560px]", "h-[440px]", "h-[440px]", "h-[440px]", "h-[440px] lg:h-[480px]"];

const Card = ({ d, i, onPick }) => (
  <motion.div className={SPANS[i]} initial={{ opacity: 0, y: 60 }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }} transition={{ duration: 1, delay: (i % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}>
    <button data-testid={`destination-card-${d.id}`} onClick={() => onPick(d.name)}
      className={`group relative block w-full overflow-hidden rounded-[2rem] text-left ${HEIGHTS[i]}`}>
      <img src={d.img} alt={d.name} loading="lazy"
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.6s] ease-[cubic-bezier(.16,1,.3,1)] group-hover:scale-110" />
      <div className="absolute inset-0 bg-gradient-to-t from-selva/95 via-selva/20 to-transparent" />
      <div className="absolute left-6 right-6 top-6 flex flex-wrap gap-2">
        <span className="rounded-full bg-arena/90 px-3 py-1 text-xs font-bold uppercase tracking-wider text-selva">{d.region}</span>
        <span className="flex items-center gap-1 rounded-full bg-mar px-3 py-1 text-xs font-bold text-white"><Car className="h-3 w-3" />{d.mode}</span>
        <span className="flex items-center gap-1 rounded-full bg-selva/70 px-3 py-1 text-xs font-bold text-arena backdrop-blur"><Clock className="h-3 w-3" />{d.days}</span>
      </div>
      <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 p-6 sm:p-8">
        <div>
          <h3 className="font-display text-3xl font-extrabold tracking-tight text-arena sm:text-5xl">{d.name}</h3>
          <div className="mt-3 flex flex-wrap gap-2">
            {d.tags.map((t) => <span key={t} className="text-sm text-arena/85">· {t}</span>)}
          </div>
        </div>
        <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-sol text-selva transition-transform duration-500 group-hover:rotate-45 group-hover:scale-110">
          <ArrowUpRight className="h-6 w-6" />
        </span>
      </div>
    </button>
  </motion.div>
);

export const Destinations = ({ onPick }) => {
  const pick = (name) => { onPick(name); scrollToId("contacto"); };
  return (
    <section id="destinos" data-testid="destinations-section" className="bg-arena pb-24 lg:pb-36">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-16">
        <div className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <Reveal>
            <Overline>Destinos</Overline>
            <h2 className="font-display text-4xl font-extrabold leading-[0.95] tracking-tight text-selva sm:text-6xl">
              Seis Brasiles, <br /><span className="font-serif-i font-normal text-mar">un solo viaje.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-sm text-base text-tinta/75">Toca un destino y lo sumamos a tu solicitud. Combinamos varios en un mismo itinerario.</p>
          </Reveal>
        </div>
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-12 lg:gap-6">
          {DESTINOS.map((d, i) => <Card key={d.id} d={d} i={i} onPick={pick} />)}
        </div>
      </div>
    </section>
  );
};
